
@if ((message && message.length > 0) ||
  (messageArr && messageArr.length > 0)) {
  <div
    class="alert alert-danger">
    <div class="row g-3">
      <div class="col-auto align-self-center">
        <i class="bi bi-exclamation-triangle-fill" style="font-size:1.5rem"></i>
      </div>
      <div class="col align-self-center">
        @if (messageArr && messageArr.length > 0) {
          @for (error of messageArr; track error) {
            <p class="mb-1">{{error}}</p>
          }
        }
        @if (message && message.length > 0) {
          <p class="mb-0">{{message}}</p>
        }
      </div>
    </div>
  </div>
}
